import Vue from 'vue'
import {utils} from "./utils";
import {errorHandler} from "./errorHandler";
Vue.prototype.$utils = utils;
window.$utils = utils;

import Swal from "sweetalert2";
window.Swal = Swal;
const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 1500,
    showCloseButton: true,
    customClass: 'toastr',
    timerProgressBar: true,
    didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
});
window.Toast = Toast;

window.franchiseTomcatApi = `https://overflow.abc.co.zm:8443/Franchise_OnlineServer/`
window.errorHandler = errorHandler
window.Signupapi = `https://lna.abc.co.zm/SynergyApi/api/v1/store-registration/smart-invoice/`
// window.Signupapi = `https://lna.abc.co.zm/SynergyApi/api/v1/store-registration/smart-invoice/`
// window.signupStatus = `http://mcc:8181/lytSI/api/v1/smart-invoice-signup/`
window.signupStatus = `https://lna.abc.co.zm/lytSI/api/v1/smart-invoice-signup/`
window.directorStatus = signupStatus;


window.generateUUID = () => {
    let uuid = '', i, random;
    for (i = 0; i < 32; i++) {
        random = Math.random() * 16 | 0;
        if (i === 8 || i === 12 || i === 16 || i === 20) {
            uuid += '-';
        }
        uuid += (i === 12 ? 4 : (i === 16 ? (random & 3 | 8) : random)).toString(16);
    }
    return uuid;
}